import { getJson } from '@/lib/apiClient';
import type { AiHealthResponse, HealthResponse } from '@/types/api';

export const diagnosticsApi = {
  controlPlaneHealth: () => getJson<HealthResponse>('/health'),
  aiHealth: () => getJson<AiHealthResponse>('/diagnostics/ai-health'),
};

export const diagnosticsKeys = {
  controlPlane: ['diagnostics', 'control-plane'] as const,
  ai: ['diagnostics', 'ai'] as const,
};
